import React from "react";
import { Box, TextField, MenuItem, InputAdornment } from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import SearchIcon from "@mui/icons-material/Search";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";

function ReportFilters({
	searchValue,
	onSearchChange,
	searchPlaceholder = "Buscar...",
	dateFrom,
	dateTo,
	onDateFromChange,
	onDateToChange,
	extraFilters = [],
}) {
	return (
		<Box sx={{
			display: "flex",
			flexWrap: "wrap",
			alignItems: "center",
			gap: 1.5,
			border: "1px solid #dfe3e8",
			borderRadius: "12px",
			bgcolor: "white",
			p: 1.5,
		}}>
			<FilterListIcon sx={{ fontSize: 18, color: "#8e9bae" }} />
			{searchPlaceholder && (
				<TextField
					size="small"
					placeholder={searchPlaceholder}
					value={searchValue}
					onChange={(e) => onSearchChange(e.target.value)}
					InputProps={{
						startAdornment: (
							<InputAdornment position="start">
								<SearchIcon sx={{ fontSize: 16, color: "#8e9bae" }} />
							</InputAdornment>
						),
					}}
					sx={{ width: 200, "& .MuiInputBase-input": { fontSize: "0.8rem", py: 0.75 } }}
				/>
			)}
			{onDateFromChange && (
				<Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
					<CalendarTodayIcon sx={{ fontSize: 14, color: "#8e9bae" }} />
					<TextField
						type="date"
						size="small"
						value={dateFrom || ""}
						onChange={(e) => onDateFromChange(e.target.value)}
						sx={{ width: 150, "& .MuiInputBase-input": { fontSize: "0.8rem", py: 0.75 } }}
					/>
					<Box component="span" sx={{ fontSize: "0.75rem", color: "#8e9bae" }}>até</Box>
					<TextField
						type="date"
						size="small"
						value={dateTo || ""}
						onChange={(e) => onDateToChange(e.target.value)}
						sx={{ width: 150, "& .MuiInputBase-input": { fontSize: "0.8rem", py: 0.75 } }}
					/>
				</Box>
			)}
			{extraFilters.map((filter) => (
				<TextField
					key={filter.label}
					select
					size="small"
					value={filter.value}
					onChange={(e) => filter.onChange(e.target.value)}
					sx={{ width: 160, "& .MuiInputBase-input": { fontSize: "0.8rem", py: 0.75 } }}
				>
					<MenuItem value="todos">Todos</MenuItem>
					{filter.options.map((opt) => (
						<MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>
					))}
				</TextField>
			))}
		</Box>
	);
}

export default ReportFilters;
